import { useTranslation } from "react-i18next";
import { useSessions } from "../../hooks/queries";

export function CapacityMeter() {
  const { t } = useTranslation();
  const cap = useSessions().data?.capacity;
  if (!cap) return null;
  const tone = cap.percent >= 90 ? "text-red-400" : cap.percent >= 70 ? "text-amber-300" : "text-emerald-400";
  return (
    <div className="mt-6 hidden rounded-2xl border border-[#252C63] bg-[#151944] p-3.5 md:block" role="status" aria-live="polite">
      <div className="mb-1.5 flex items-center justify-between text-xs font-bold">
        <span className="text-gray-300">{t("capacity.title")}</span>
        <span className={tone}>
          <span className="num">{cap.occupied} / {cap.capacity}</span> {t("capacity.kids")}
        </span>
      </div>
      <div className="h-2 w-full overflow-hidden rounded-full bg-cosmic-navy" role="progressbar" aria-valuenow={cap.percent} aria-valuemin={0} aria-valuemax={100}>
        <div className="h-full rounded-full bg-gradient-to-r from-cosmic-purple to-success transition-all duration-500" style={{ width: `${cap.percent}%` }} />
      </div>
      <p className="mt-2 text-[10px] text-gray-400">{t("capacity.available", { count: cap.available })}</p>
    </div>
  );
}
